import React from 'react';

export type Props = {
  children: React.ReactNode;
};

const CustomHeader: React.FC<Props> = props => {
  return <>{props.children}</>;
};

export default CustomHeader;
